// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__iG8Ga","alert":"SettungsInbox_alert__3lB-c"};